import React from "react";
import { useState, useRef } from 'react'
import { Button, Form, Modal, Row, Alert, ButtonGroup } from "react-bootstrap";
import {  Pencil } from 'react-bootstrap-icons';
import IconPicker from "../components/IconPicker";
import InputGroup from 'react-bootstrap/InputGroup';


const ModalForEditRow = (props) => {
    const { currentRow, updateRow, whenfinished} = props;
    const titleRef = useRef(null);
    const subtitleRef = useRef(null);
    const shortTelRef = useRef(null);
    const longTelRef = useRef(null);
    const posteRef = useRef(null);
    const sectionRef = useRef(null);
    const [errorMsg, setErrorMsg] = useState("");

    const [iconSelected, setIconSelected] = useState(null);

    const getIconForm = () => {
        let anIcon = {};
            if(iconSelected){
                anIcon = iconSelected;
            } else if (currentRow?.iconname && currentRow?.icontype){
                anIcon = {iconName: currentRow?.iconname, iconType: currentRow?.icontype};
            } else {
                anIcon = {iconName: 'user-md', iconType: 'awsome'};
            }
            //console.log("(modalForEdit)Icon selected = " + anIcon.iconName + " - " + anIcon.iconType);
            return anIcon;
        }

    const handleSubmitEditTel = async (e) => {
        e.preventDefault();
        handleResult();
        if(whenfinished) whenfinished();

    }

    const handleResult = () => {
        let iconToUpdate= getIconForm();
        let result = {
            'sectiontitle': sectionRef.current?.value, 
            'title': titleRef.current?.value, 
            'subtitle': subtitleRef.current?.value, 
            'numero_court': shortTelRef.current?.value, 
            'numero': longTelRef.current?.value,
            'poste': posteRef.current?.value,
            'iconname': iconToUpdate.iconName,
            'icontype': iconToUpdate.iconType,
         };
         updateRow(result);
    }


    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Modifier un numéro de téléphone
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSubmitEditTel}>
                    <Row className="mb-3">
                        <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon1">Section</InputGroup.Text>
                        <Form.Control type="text" ref={sectionRef} defaultValue={currentRow ? currentRow.sectiontitle : null} required />
                        </InputGroup>

                        <InputGroup className="mb-3">
                        {/* <InputGroup.Text id="basic-addon1"><IconField iconname={getIconForm().iconName} icontype={getIconForm().iconType} /></InputGroup.Text> */}
                        <InputGroup.Text id="basic-addon2">Titre</InputGroup.Text>
                        <Form.Control type="text" ref={titleRef} defaultValue={currentRow ? currentRow.title : null} required />
                        </InputGroup>

                        <InputGroup className="mb-3">
                        {/* <InputGroup.Text id="basic-addon1"><IconField iconname={getIconForm().iconName} icontype={getIconForm().iconType} /></InputGroup.Text> */}
                        <InputGroup.Text id="basic-addon3">Sous titre</InputGroup.Text>
                        <Form.Control type="text" ref={subtitleRef} defaultValue={currentRow ? currentRow.subtitle : null} required />
                        </InputGroup>

                        <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon4">Téléphone Court</InputGroup.Text>
                        <Form.Control type="text" ref={shortTelRef} defaultValue={currentRow ? currentRow.numero_court : null} />
                        </InputGroup>

                        <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon5">Téléphone Long</InputGroup.Text>
                        <Form.Control type="text" ref={longTelRef} defaultValue={currentRow ? currentRow.numero : null}/>
                        </InputGroup>

                        <InputGroup className="mb-3">
                        <InputGroup.Text id="basic-addon5">Poste Fixe</InputGroup.Text>
                        <Form.Control type="text" ref={posteRef} defaultValue={currentRow ? currentRow.poste : null}/>
                        </InputGroup>

                        <IconPicker callback={ 
                            (icon) => {
                                console.log("Choosed " + icon.iconName + " - " +icon.iconType);
                                setIconSelected(icon);
                            } 
                            } initialIcon={getIconForm()}/>
                    </Row>
                    {errorMsg && (
                        <Alert
                            variant="danger"
                            onClose={() => setErrorMsg("")}
                            dismissible>
                            {errorMsg}
                        </Alert>
                    )}
                    <div className="text-center mt-2">
                        <ButtonGroup>
                            <Button type="submit" className="w-50"><Pencil size={32}/>Modifier</Button>
                        </ButtonGroup>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}

export default ModalForEditRow;